import React, { useState } from "react";
import * as Styles from "../Farmers/components/FarmerForm/style";
import close from "../assets/images/close.png";
import * as Yup from "yup";
import { Formik, Field, FieldArray } from "formik";
import { InputGroup } from "../shared/InputGroup/InputGroup2";
import { SelectGroup } from "../shared/SelectGroup/SelectGroup";
import Select from "react-select";
import { toast } from "react-toastify";
import { MultiSelect } from "react-multi-select-component";
import Cookies from "universal-cookie";
import { useEffect } from "react";
import axios from "axios";

const cookies = new Cookies();

const hiveCameraInitialValues = {
  devBoard: "",
  cameraModel: "",
  cameraResolution: "",
  videoStreamEnabled: "yes",
  videoStreamQuality: "",
  captureIntervalSeconds: 0,
  storageLocation: "",
  gsmSimNumber: "",
  communicationProtocol: ["wifi"],
  macAddress: "",
  solarAttached: "yes",
  batteryLevel: 0,
  firmwareVersion: "",
  installationDate: "",
  status: "active",
};

const hiveCameraSchema = Yup.object().shape({
  devBoard: Yup.string().required("Dev board is required"),
  cameraModel: Yup.string().required("Camera model is required"),
  cameraResolution: Yup.string().required("Camera resolution is required"),
  videoStreamEnabled: Yup.string()
    .oneOf(["yes", "no"])
    .required("Video stream enabled status is required"),
  videoStreamQuality: Yup.string().required("Video stream quality is required"),
  captureIntervalSeconds: Yup.number()
    .required("Capture interval is required")
    .min(1),
  storageLocation: Yup.string().required("Storage location is required"),
  gsmSimNumber: Yup.string()
    .required("GSM SIM number is required")
    .matches(/^[+]?[0-9]{10,15}$/, "Mobile number is not valid"),
  macAddress: Yup.string().required("MAC address is required"),
  solarAttached: Yup.string()
    .oneOf(["yes", "no"])
    .required("Solar attached status is required"),
  batteryLevel: Yup.number()
    .required("Battery level is required")
    .min(0)
    .max(100),
  firmwareVersion: Yup.string().required("Firmware version is required"),
  installationDate: Yup.date().required("Installation date is required"),
  status: Yup.string()
    .oneOf(["active", "inactive"], "Invalid status")
    .required("Status is required"),
});

const communicationProtocol = [
  { value: "bluetooth", label: "bluetooth" },
  { value: "wifi", label: "wifi" },
  { value: "GSM", label: "GSM" },
];
const metrics = [
  "temperature",
  "pressure",
  "humidity",
  "co2_gas",
  "audio",
  "image",
  "video",
];

const boardNames = ["esp32_nodemcu", "raspberry_pi_zero_2_w"];
const status = ["active", "inactive"];
const sensorCommunicationProtocols = ["i2s", "spi"];
const yesOrNo = ["yes", "no"];
export const AddHiveCameraForm = (props) => {
  const { handleClose } = props;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formdata, setformdata] = useState(hiveCameraInitialValues);
  const [hiveId, setinHiveId] = useState([]);
  const [selectedCommunicationProtocol, setselectedCommunicationProtocol] =
    useState([{ value: "wifi", label: "wifi" }]);
  const [selectedHiveId, setselectedHiveId] = useState([]);
  const [type, settype] = useState("create");
  const getInHiveSensor = async () => {
    try {
      const currentToken = cookies.get("access_token");

      const headers = {
        headers: {
          authorization: `Bearer ${currentToken}`,
        },
      };
      const res = await axios.get(
        `${process.env.REACT_APP_HUMBLEBEE_API_URL}/sensors/hives`,
        headers
      );
      if (res.data) {
        const data = res.data.map((it) => ({
          value: it.hive_id,
          label: it.hive_id,
        }));
        setinHiveId(data);
      }
    } catch (error) {
      console.log(error);
      toast.error("Error in getting inhive sensors data");
    }
  };

  useEffect(() => {
    getInHiveSensor();
    if (props.type == "edit") {
      const initialData = props.intialData;
      const formadata2 = {
        devBoard: initialData.dev_board || "",
        cameraModel: initialData.camera_model || "",
        cameraResolution: initialData.camera_resolution || "",
        videoStreamEnabled: initialData.video_stream_enabled ? "yes" : "no",
        videoStreamQuality: initialData.video_stream_quality || "",
        captureIntervalSeconds: initialData.capture_interval_seconds || 0,
        storageLocation: initialData.storage_location || "",
        gsmSimNumber: initialData.gsm_sim_number || "",
        communicationProtocol:
          initialData.communication_protocol?.map((it) => ({
            value: it,
            label: it,
          })) || [],
        macAddress: initialData.mac_address || "",
        solarAttached: initialData.solar_attached ? "yes" : "no",
        batteryLevel: initialData.battery_level || 0,
        firmwareVersion: initialData.firmware_version || "",
        installationDate: initialData.installation_date || "",
        status: initialData.status || "active",
      };
      setselectedCommunicationProtocol(formadata2.communicationProtocol);
      setselectedHiveId(
        initialData.hive_id?.map((it) => ({
          value: it,
          label: it,
        })) || []
      );
      console.log(formadata2, initialData);
      setformdata(formadata2);
      settype(props.type);
    }
  }, []);

  const handleSubmit = async (values, { resetForm }) => {
    try {
      if (selectedHiveId?.length === 0) {
        toast.error("Please select at least one hive Id");
        return;
      }
      if (selectedCommunicationProtocol?.length === 0) {
        toast.error("Please select at least one Communication Protocol");
        return;
      }
      setIsSubmitting(true);
      const payload = {
        hive_camera_id: `camera_${Date.now()}`,
        hive_id: selectedHiveId.map((it) => it.value),
        dev_board: values.devBoard,
        camera_model: values.cameraModel,
        camera_resolution: values.cameraResolution,
        video_stream_enabled: values.videoStreamEnabled === "yes",
        video_stream_quality: values.videoStreamQuality,
        capture_interval_seconds: values.captureIntervalSeconds,
        storage_location: values.storageLocation,
        gsm_sim_number: values.gsmSimNumber,
        communication_protocol: selectedCommunicationProtocol.map(
          (it) => it.value
        ),
        mac_address: values.macAddress,
        solar_attached: values.solarAttached === "yes",
        battery_level: values.batteryLevel,
        firmware_version: values.firmwareVersion,
        installation_date: values.installationDate,
        last_seen: new Date().toISOString(),
        status: values.status,
      };

      console.log("Payload being sent:", payload);
      const currentToken = cookies.get("access_token");

      const headers = {
        authorization: `Bearer ${currentToken}`,
        "Content-Type": "application/json",
      };
      const response = await fetch(
        `${process.env.REACT_APP_HUMBLEBEE_API_URL}/sensors/register/hive-camera`,
        {
          method:type=='edit'?'PUT':"POST",
          headers: headers,
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error response:", errorData);
        toast.error("Error: Hive Camera not submitted");
        return;
      }

      const result = await response.json();
      console.log("Success:", result);
      toast.success("Hive Camera submitted successfully");
      resetForm();
      handleClose2();
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error: Hive Camera not submitted");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose2 = () => {
    handleClose();
  };
  console.log(formdata, selectedCommunicationProtocol);

  return (
    <Styles.ModalContent>
      <Formik
        initialValues={formdata}
        onSubmit={handleSubmit}
        validationSchema={hiveCameraSchema}
        validateOnMount
        enableReinitialize={true}
      >
        {(formik) => (
          <Styles.FormWithCloseButton>
            {console.log(formik.values)}
            <Styles.CloseButtonDiv>
              <h3>{type=='edit'?'Edit':'Add'} Inhive Camera</h3>
              <Styles.FormCloseButton2 onClick={handleClose2}>
                <img src={close} alt="Close" />
              </Styles.FormCloseButton2>
            </Styles.CloseButtonDiv>

            {/* Main Bode of Form Starts */}
            <Styles.MainFarmerFormDiv>
              <Styles.RowFlex>
                <InputGroup
                  PlaceholderText="Enter Firmware Version"
                  LabelText="Firmware Version"
                  name="firmwareVersion"
                  type="text"
                  star="*"
                  onChange={formik.handleChange}
                  value={formik.values.firmwareVersion}
                />
                {/* {console.log(formik.errors, formik.touched)} */}

                <InputGroup
                  PlaceholderText="Enter Dev Board"
                  LabelText="Dev Board"
                  name="devBoard"
                  type="text"
                  star="*"
                  onChange={formik.handleChange}
                  value={formik.values.devBoard}
                />
              </Styles.RowFlex>

              <Styles.RowFlex>
                <SelectGroup
                  PlaceholderText="Is Solar Attached"
                  LabelText="Solar Attached"
                  name="solarAttached"
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                  options={yesOrNo}
                  value={formik.values.solarAttached}
                  star="*"
                />
                <SelectGroup
                  PlaceholderText="Enter Status"
                  LabelText="Status"
                  name="status"
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                  options={status}
                  value={formik.values.status}
                  star="*"
                />
              </Styles.RowFlex>

              <Styles.RowFlex>
                <SelectGroup
                  PlaceholderText="Is Video Stream Enabled?"
                  LabelText="Video Stream Enabled"
                  name="videoStreamEnabled"
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                  options={yesOrNo}
                  value={formik.values.videoStreamEnabled}
                  star="*"
                />

                <InputGroup
                  PlaceholderText="Enter Video Stream Quality"
                  LabelText="Video Stream Quality"
                  name="videoStreamQuality"
                  type="text"
                  star="*"
                  value={formik.values.videoStreamQuality}
                  onChange={formik.handleChange}
                />
              </Styles.RowFlex>

              <Styles.RowFlex>
                <InputGroup
                  PlaceholderText="Enter Camera Model"
                  LabelText="Camera Model"
                  value={formik.values.cameraModel}
                  name="cameraModel"
                  type="text"
                  star="*"
                  onChange={formik.handleChange}
                />

                <InputGroup
                  PlaceholderText="Enter Camera Resolution"
                  LabelText="Camera Resolution"
                  name="cameraResolution"
                  value={formik.values.cameraResolution}
                  type="text"
                  star="*"
                  onChange={formik.handleChange}
                />
              </Styles.RowFlex>
              <Styles.RowFlex>
                <InputGroup
                  PlaceholderText="Enter Capture Interval in Seconds"
                  LabelText="Capture Interval (Seconds)"
                  name="captureIntervalSeconds"
                  value={formik.values.captureIntervalSeconds}
                  type="text"
                  star="*"
                  onChange={formik.handleChange}
                />

                <InputGroup
                  PlaceholderText="Enter Storage Location"
                  LabelText="Storage Location"
                  name="storageLocation"
                  type="text"
                  star="*"
                  value={formik.values.storageLocation}
                  onChange={formik.handleChange}
                />
              </Styles.RowFlex>
              <Styles.RowFlex>
                <InputGroup
                  PlaceholderText="Enter GSM SIM Number"
                  LabelText="GSM SIM Number"
                  name="gsmSimNumber"
                  type="text"
                  value={formik.values.gsmSimNumber}
                  star="*"
                  onChange={formik.handleChange}
                />

                <InputGroup
                  PlaceholderText="Enter MAC Address"
                  LabelText="MAC Address"
                  name="macAddress"
                  value={formik.values.macAddress}
                  type="text"
                  star="*"
                  onChange={formik.handleChange}
                />
              </Styles.RowFlex>
              <Styles.RowFlex>
                <InputGroup
                  PlaceholderText="Enter Battery Level"
                  LabelText="Battery Level"
                  name="batteryLevel"
                  value={formik.values.batteryLevel}
                  type="text"
                  star="*"
                  onChange={formik.handleChange}
                />
                <InputGroup
                  PlaceholderText="Enter Installation Date"
                  LabelText="Installation Date"
                  name="installationDate"
                  type="date"
                  value={formik.values.installationDate ? new Date(formik.values.installationDate).toISOString().split("T")[0] : ""}
                  star="*"
                  onChange={formik.handleChange}
                />
              </Styles.RowFlex>

              <div
                className="multi-select-group"
                style={{ marginBottom: "20px", marginTop: "20px" }}
              >
                <label>Select Hive Id</label>
                <MultiSelect
                  options={hiveId}
                  value={selectedHiveId}
                  onChange={setselectedHiveId}
                  labelledBy="Select Hive Id *"
                  hasSelectAll={false}
                />
              </div>
              <div
                className="multi-select-group"
                style={{ marginBottom: "20px", marginTop: "20px" }}
              >
                <label>Select Communication Protocol</label>
                <MultiSelect
                  options={communicationProtocol}
                  value={selectedCommunicationProtocol}
                  onChange={setselectedCommunicationProtocol}
                  labelledBy="Select Communication Protocol*"
                  hasSelectAll={false}
                />
              </div>
            </Styles.MainFarmerFormDiv>

            {/* Main Body of Form stops */}

            <Styles.CreateFarmerButton type="submit">
              {isSubmitting ? "Submitting..." : type=='edit'? 'Update'  : "Create"}
            </Styles.CreateFarmerButton>
          </Styles.FormWithCloseButton>
        )}
      </Formik>
    </Styles.ModalContent>
  );
};
